import { PricingDeal } from './types';

export const PROD_CATEGORY = {
	booking: 'Booking',
};

export const PRODUCT_EVENT = {
	cardClick: 'cardClick',
	favorite: {
		shared: 'favoritesShared',
		added: 'favoritesAdded',
		removed: 'favoritesRemoved',
	},
};

export const EVENT_TYPE = {
	interaction: 'interaction',
};

export const COMPONENT = {
	cruiseCard: 'cruiseCard',
	roomViewPanel: 'roomViewPanel',
};

export const STATEROOM_CLASS_TO_DEAL: Record<string, PricingDeal> = {
	OUTSIDE: PricingDeal.Outside,
	BALCONY: PricingDeal.Balcony,
	DELUXE: PricingDeal.Suite,
};
